<template>
  <div class="adminLogin">
    <v-card class="py-8 px-10">
      <h3 class="mb-6 text-center">後台登入</h3>
      <span>Email</span>
      <v-text-field
        outlined
        dense
        v-model="email"
      ></v-text-field>
      <span>密碼</span>
      <v-text-field
        outlined
        dense
        type="password"
        @keydown.enter="login"
        v-model="password"
      ></v-text-field>
      <v-btn dark rounded block height="40" color="pink" class="mt-5" @click="login">登入</v-btn>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      email: '',
      password: ''
    }
  },
  created() {
    if(this.isLogin) {
      this.$router.push('/admin/seller')
    }
  },
  computed: {
    ...mapGetters('admin', ['isLogin'])
  },
  methods: {
    login() {
      this.axios.post('/admin', {
        email: this.email,
        password: this.password
      }).then(response => {
        this.$store.dispatch('admin/login', `Bearer ${response.data.access_token}`)
        this.$router.push('/admin/seller')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '登入失敗')
        this.email = ''
        this.password = ''
      })
    }
  }
}
</script>

<style lang="scss">
.adminLogin {
  background-color: #202020;
  position: relative;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  &:before {
    content: 'ADMIN';
    font-weight: 600;
    position: absolute;
    color: rgba(0, 0, 0, .3);
    font-size: 400px;
    transform: rotate(13deg);
    @include tablet {
      font-size: 250px;
      transform: rotate(50deg);
    }
    @include mobile {
      font-size: 250px;
      transform: rotate(50deg);
    }
  }
  .v-card {
    width: 400px;
    label {
      font-size: 14px;
    }
    a {
      font-size: 12px;
    }
    span {
      font-size: 12px;
    }
  }
}
</style>